import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import Auth from '../../Layout/Auth';

import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Lazy load components for better performance
const AdminUserList = lazy(() => import('../Users/Pages/User/Users'));
const RoleList = lazy(() => import('../Role/Role'));
// const CustomerList = lazy(() => import('../../../src/V4/Modules/Customer/Routes/CustomerRoute'));
// Include Customer routes directly
import CustomerRoute from '../../V4/Modules/Customer/Routes/CustomerRoute';

/**
 * Store module routes
 * @param {Object} props - Component props
 * @returns {JSX.Element} - Store routes
 */
const UserRoute = (props) => {
    const { history } = props;

    return (
        <>
            {/* Just include CustomerRoute component directly */}
            <CustomerRoute />
            <Route
                exact
                path="/:lng/user/user"
                render={() => (
                    <Auth history={history} allowedRoles={['admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <AdminUserList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/user/role"
                render={() => (
                    <Auth history={history} allowedRoles={['admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <RoleList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            {/* Customer routes are already defined within CustomerRoute component */}

        </>
    );
};
function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
export default UserRoute;
